import React, {useEffect, useState} from 'react'
import axios from 'axios'
import { errorToast, successToast } from '../../utils/notification';
import Loader from '../../components/Loader';
import axiosInstance from '../../utils/api';

var mqtt = require('mqtt/dist/mqtt');

const mqtt_username = process.env.REACT_APP_MQTT_USERNAME;
const mqtt_password = process.env.REACT_APP_MQTT_PASSWORD;
const mqtt_server = process.env.REACT_APP_MQTT_SERVER;

const RemoteReset = () => {
    const [devices, setDevices] = useState([])
    const [deviceId, setDeviceId] = useState(null)
    const [telemetry, setTelemetry] = useState(null)
    const [deviceName, setDeviceName] = useState(null)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        getResetDevices()
    }, [])
    
    const getResetDevices =()=> {
        axiosInstance.get(`https://api.cl-ds.com/admin/reset/agridose`).then(res=>{
            setDevices(res.data)
        }).catch(err=>{
            console.log(err)
        })
    }

    function handleChange(e) {
        setTelemetry(e.target[e.target.selectedIndex].getAttribute('data-telemetry'))
        setDeviceName(e.target[e.target.selectedIndex].innerHTML)
        setDeviceId(e.target.value)
    }


    function reset() {
        if (deviceId == null)  return errorToast('Please select a device')

        setLoading(true)
        var client_1 = mqtt.connect(`wss://${mqtt_server}:9001`, {
            username: mqtt_username,
            password: mqtt_password
        })

        
        let aswrPayload = `{
            "${deviceName}": {
                "reset" : "1"
            }
        }`

        if (telemetry == '5.0') {
            aswrPayload = `{
                "messageId" : "${deviceId}",
                "devices" : [{
                    "deviceId" : "${deviceName}",
                    "deviceData": {
                        "reset" : "1"
                      }
                    }]
                }`;
        }

        
        client_1.on('connect', function () {
            console.log(`*** subscribing to 'farm/aswa/${deviceId}'...`);
            client_1.subscribe('farm/aswa/' + deviceId, function (err) {
                if (err) {
                    setLoading(false)
                    errorToast('Unable to subscribe to remote')
                } else {
                    console.log(`*** subscribed to farm/aswa/${deviceId}.`);
                    console.log(`*** publishing to farm/aswr/${deviceId}:`, aswrPayload);
                    client_1.publish('farm/aswr/' + deviceId, aswrPayload, (err) => {
                        if (err) {
                            setLoading(false)
                            errorToast('Error publishing to remote');
                        } else {
                            axiosInstance.post('https://api.cl-ds.com/admin/reset/agridose/', {'serial': deviceName}).then(res=>{
                                setLoading(false)
                                successToast('Reset Succesfully')
                            }).catch(err=>{
                                setLoading(false)
                                errorToast('Unable to reset remote. Please Contact Administrator.')
                            })
                        }
                    })
                }
            });
        })
    }

    return (
        <div style={{padding:20}}>
            {loading ? (
                <>
                <Loader/>
                </>
            ) : (
                <>
                <select className="form-control mb-3" onChange={(e)=>{handleChange(e)}}>
                {devices.length < 1 && (
                    <option value={null}>Loading...</option>
                )}
                {devices.map(d => {
                    return (
                        <option value={d.device_id} data-telemetry={d.telemetry} key={d.device_id}>{d.serial}</option>
                    )
                })}
                </select>

                <div style={{display:'flex', alignItems:'center', justifyContent:'center'}}>
                <button class="btn btn-lg btn-primary" onClick={()=>{reset()}}>Reset</button>
                </div>
                </>
            )}
        </div>
    )
}

export default RemoteReset